/** App-level routes (first URL segment) — not community ids. Used when inferring id from pathname. */
export const ROOT_PATH_SEGMENTS = new Set([
  'login',
  'register',
  'forgot-password',
  'dashboard',
  'create-community',
  'account-settings',
  'profile',
  'invite',
  'i',
  'u',
  'b',
  'ub',
  'posts',
  'admin',
  'debug-calendar',
  'privacy',
  'terms',
  'contact',
  'csae',
  'e',
  'events',
]);

/**
 * React Router v7 can omit parent `/:communityId` in `useParams()` in some cases; layouts still match
 * `/segment/dashboard`, so we recover the segment from the pathname.
 */
export function communityIdFromPathname(pathname: string): string | undefined {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  const m = normalized.match(/^\/([^/]+)/);
  const seg = m?.[1];
  if (!seg || ROOT_PATH_SEGMENTS.has(seg)) return undefined;
  return seg;
}

const COMMUNITY_ID_PATTERN = /^[0-9A-Za-z]{10}$/;
const COMMUNITY_SLUG_PATTERN = /^[a-z0-9-]+$/;

export function isCommunityId(segment: string): boolean {
  return COMMUNITY_ID_PATTERN.test(segment) && !segment.includes('-');
}

export function isCommunitySlug(segment: string): boolean {
  return segment.length >= 1 && segment.length <= 100 && COMMUNITY_SLUG_PATTERN.test(segment);
}

export function communityDetailApiPath(routeSegment: string): string {
  if (isCommunityId(routeSegment)) {
    return `/api/communities/id/${routeSegment}`;
  }
  if (isCommunitySlug(routeSegment)) {
    return `/api/communities/slug/${routeSegment}`;
  }
  return `/api/communities/${routeSegment}`;
}
